import React from 'react';

const LOGO_SYMBOL = 'https://customer-assets.emergentagent.com/job_3118c9a4-a94d-4f60-9004-669a5548876d/artifacts/9jvjmy2x_GWINS_Symbol_Metallic_2000px.png';

const AboutLogo = () => {
  const stats = [
    { value: '2022', label: 'Founded' },
    { value: '100%', label: 'Player-Made' },
    { value: '∞', label: 'Passion' },
  ];

  return (
    <section className="section-padding relative overflow-hidden bg-[#0a0b0c]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header - Centered */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#00d4aa] text-sm font-bold uppercase tracking-widest mb-4">
            The Legend Behind The Mark
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white">
            About <span className="text-[#00d4aa]">GWINS</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Logo Display */}
          <div className="flex justify-center">
            <div className="relative">
              {/* Decorative glow behind logo */}
              <div className="absolute inset-0 -z-10 blur-3xl bg-[#00d4aa]/15 rounded-full scale-90" />
              <img
                src={LOGO_SYMBOL}
                alt="GWINS Emblem"
                className="relative w-72 sm:w-96 lg:w-[450px] h-auto drop-shadow-2xl"
                style={{
                  filter: 'drop-shadow(0 0 40px rgba(0, 212, 170, 0.25))'
                }}
              />
            </div>
          </div>

          {/* Content */}
          <div>
            {/* Description */}
            <div className="space-y-5 text-white/80 leading-relaxed mb-8">
              <p>
                The <span className="text-[#00d4aa] font-semibold">GWINS</span> emblem isn't just a logo—it's a <span className="text-white font-semibold">battle standard</span>.
              </p>
              <p>
                The sharp, angular design represents the <span className="text-white font-semibold">precision and velocity</span> of paintball—every edge calculated, every line purposeful. The interlocking forms symbolize <span className="text-white font-semibold">unity in competition</span>: teammates moving as one, strategies executed in perfect sync.
              </p>
              <p>
                The metallic teal accent cutting through represents the <span className="text-[#00d4aa] font-semibold">moment of breakthrough</span>—that split-second when training meets opportunity and victory becomes inevitable.
              </p>
            </div>

            {/* Quote */}
            <blockquote className="relative pl-6 border-l-2 border-[#00d4aa] mb-12">
              <p className="text-white/90 italic text-lg leading-relaxed">
                "We don't just play to compete. We play to dominate. Every mark we wear, every gear we craft, carries this philosophy."
              </p>
            </blockquote>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4">
              {stats.map((stat, index) => (
                <div 
                  key={index} 
                  className="text-center py-6 px-4 border border-white/10 rounded-lg hover:border-[#00d4aa]/30 transition-colors"
                >
                  <p className="text-3xl sm:text-4xl font-black text-[#00d4aa] mb-2">
                    {stat.value}
                  </p>
                  <p className="text-white/50 text-xs uppercase tracking-widest">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutLogo;
